module.exports = __webpack_public_path__ + "img/updated_icon.f60293bf.svg";